import { Worker, Viewer } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

type Props = {
  document: string
  loader: React.ReactNode
  onError?: () => void
}

export default function PdfViewer({ document, loader, onError }: Props): JSX.Element {
  return (
    <div style={{ height: '100vh' }}>
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
        <Viewer
          fileUrl={document}
          renderLoader={percentages => (
            <div>
              {loader}
              <p>Cargando: {percentages}%</p>
            </div>
          )}
        />
      </Worker>
    </div>
  )
}
